<template>
	<div id="app" :class="[!user ? 'login' : '' ]"  >
		<Menu v-if="user" />
		<Loading v-if="validatingToken" />
		<Content v-else />	
	</div>
</template>

<script>
import axios from 'axios'
import { baseApiUrl, userCredential, showError } from '@/global'
import { mapState } from 'vuex'
import Menu from '@/components/template/Menu'
import Content from '@/components/template/Content'
import Footer from '@/components/template/Footer'
import Loading from '@/components/template/Loading'

export default {
	name: 'App',
	components: { Menu, Content, Footer, Loading },    
	computed: mapState(['user']),	
	data: function() {
		return {
			validatingToken: true
		}
	},

	methods: {
		validateToken() {
			this.validatingToken = true

			const json = localStorage.getItem(userCredential)
			const userData = JSON.parse(json)
            this.$store.commit('setUser', null)

			// Se não tem nada no localstorage, não tem necessidade de validar nada ou ir no backend, encaminha para o auth/login
			if (!userData) {
				this.validatingToken = false
				this.$router.push({ name: 'auth' })
				return
			}

			// Se esta setado, então faz uma requisição 
			let validateTokenOK = {};			   

			axios.post(`${baseApiUrl}/validateToken`, userData)
				.then(resp => {
					validateTokenOK = resp.data
					if (validateTokenOK == 'OK') {    
						// Se token valido, seta userData do usuário logado 
						this.$store.commit('setUser', userData)
					} else {
						localStorage.removeItem(userCredential)
						this.$router.push({ name: 'auth' })
					} 
					this.validatingToken = false // Reseta pra não ficar validando eternamente 
				})
                .catch(showError).finally(() => {
					this.validatingToken = false
				})				  
		},

		redirectToReset() {
            this.$store.commit('setUser', null)
			this.validatingToken = false
		},

		redirectToRegister() {
            this.$store.commit('setUser', null)
			this.validatingToken = false
		}

	},

	created() {
		// Se não for reset de senha ou registro de nova empresa, entra na validação de token!
		if (this.$route.path === '/reset') {
			// Reset
			var url = new URL(window.location.href);
			var pid = url.searchParams.get("id");
			var ptoken = url.searchParams.get("token");
			if ((pid == null) || (ptoken == null)) {
				this.validateToken()
			}
			else {
				this.redirectToReset()
			}
		}
		else 
		if (this.$route.path === '/register') {
			// Registro de nova emp
			this.redirectToRegister()
		}
		else {
			// Validação de token
			this.validateToken()
		}
	}
}
</script>

<style>
	#app .modal-content {
		border-radius: 10px;
	}

	#app textarea {
		border-radius: 10px;
		border: 1px solid var(--white-medium);
		box-shadow: none !important
	}

	#app textarea:hover {
		border-color: var(--greenn);
	}

	#app .card {
		border-radius: 10px;
		border-color: var(--white-medium);
	}

	#app .card-header {
		border-color: var(--white-medium);
		border-radius: 10px 10px 0 0;
	}

	#app select {
		border: 1px solid var(--white-medium);
		border-radius: 10px;
		height: 50px;
		box-shadow: none !important;
	}
	#app input {
		height: 50px;
		border-radius: 10px;
		border: 1px solid var(--white-medium);
		padding: 10px 20px;
		transition: .3s;
	}
	#app input:hover, #app input:focus {
		border-color: var(--greenn);
		box-shadow: none !important;
	}
	#app input[type="file"] {
		position: absolute;
		width: 100%;
		height: 100%;
		opacity: 0;
		cursor: pointer;
		top: 0;
		left: 0;
		box-shadow: none !important;
	}
	#app .custom-file-label {
		display: inline-block;
		height: 39px;
		border-radius: 10px;
		border: 1px solid var(--white-medium);
		padding: 5px 20px;
		transition: .3s;
		cursor: pointer;
		box-sizing: border-box;
		line-height: 30px; 
		box-shadow: none !important;
	}
	#app .custom-file-label:hover, #app .custom-file-label:focus {
		border-color: var(--greenn);
	}

	#app .mx-input {
		height: 50px;
		border-radius: 10px;
		border: 1px solid var(--white-medium);
		padding: 5px 20px;
		transition: .3s;
		font-size: 1rem;
		font-weight: 400;
		line-height: 1.5;
		width: 115%;
	}
	#app .mx-input:hover, #app .mx-input:focus {
		border-color: var(--greenn);
		box-shadow: none !important;
	}

	#app .mx-icon-calendar, #app .mx-icon-clear {
		right: -20px;
	}

	:root {
		--greenn-dark: #006b63;
		--greenn-transparent: rgba(0,148,136,0.17254901960784313);
		--greenn: #009488;
		--greenn2: rgba(0,148,136,0.10196078431372549);
		--greenn-light: #16c3b5;
		--blue-dark: #00336f;
		--bluee: #004392;
		--blue2: rgba(0,67,146,0.10196078431372549);
		--blue-light: #2360a8;
		--orange-dark: #e7770f;
		--orange: #ff9e44;
		--orange2: rgba(255,158,68,0.10196078431372549);
		--orange-light: #feba7b;
		--red-dark: #940900;
		--red: #d31408;
		--red2: rgba(211,20,8,0.10196078431372549);
		--red-light: #f16f67;
		--gray01: #141414;
		--gray02: #4e4b59;
		--gray03: #5f5c6b;
		--gray04: #7a7786;
		--gray05: #8c8a97;
		--white-dark: #b5b9c5;
		--white-medium: #ededf0;
		--white-light: #f7f7f7;
		--white: #fff;
		--gradient: linear-gradient(88.77deg,#92c127 -73.82%,#008c95 98.93%);
	}
	* {
		font-family: "Montserrat", sans-serif;
	}
	
	body {
		margin: 0;
	}

	#app {
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;	
		height: 100vh;
	}

	#app.login .content{
		width: 100% !important;
		left: 0 !important;
	}

    #btn-principal {
		border-radius: 10px;
		height: 50px;
        transition: 0.3s;
		color: #fff;
		padding: 0 30px;
		background-color: var(--greenn);
		border-color: var(--greenn);
	}	

	#app button.close {
		color: black;
	}

	#app button {
		border-radius: 10px;
		height: 50px;
        transition: 0.3s;
		color: #fff;
		padding: 0 30px;
	}

	#app td>button:has(i), #app td>.b-dropdown > button {
		width: 40px;
		height: 40px;
		padding: 0;
	}

	#app .table {
		margin-bottom: 0;
	}

	#app .table-responsive {
		border: 1px solid var(--white-medium);
		border-radius: 10px;
	}

	#app .table-striped tbody tr:nth-of-type(odd) {
		background-color: var(--white-medium);
	}

    #btn-principal:hover { 
		background-color: var(--greenn-dark);
		border-color: var(--greenn-dark);
    }   	

	.form-control:focus {
        border-color: #009587!important;
		box-shadow: 0 0 0 0.2rem rgba(40, 167, 69, 0.25)!important;
    } 	

	.custom-control-input:checked ~ .custom-control-label::before {
		color: #fff;
        background-color: #009587!important;
        border-color: #009587!important;
	}

	.customPagination > li.active > a, .customPagination > li > a:hover {
        color: #fff;
		background-color: #5a6268!important;
		border-color: #545b62!important;
    }

    .customPagination > li.active > a:hover {
        color: #fff;
        background-color: #545b62!important;
		border-color: #5a6268!important;
		transition: 0.5s;
    }
	
    #app .pagination {
		padding-bottom: 20px;
    }

	#app .custom-input-group .b-form-input,
	.custom-input-group .form-control {
		border-top-right-radius: 0 !important;
		border-bottom-right-radius: 0 !important;
	}

	#app .custom-input-group .custom-search-button {
		padding: 0.25rem 0.4rem;
		color: #495057;
		background-color: rgba(0, 0, 0, 0.03);
		display: flex;
		align-items: center;
		justify-content: center;
		min-width: 30px;
		border-top-left-radius: 0 !important;
		border-bottom-left-radius: 0 !important;
		border-color: #5a6268 !important;
		border: 1px solid rgba(0, 0, 0, 0.03) !important; 
	}

	.custom-input-group .form-control:hover,
	.custom-input-group .form-control:hover + .custom-search-button {
		border-color: #009587 !important;
	}

	.custom-input-group .form-control:focus,
	.custom-input-group .form-control:focus + .custom-search-button {
		border-color: #009587 !important;
	}

	#app .custom-input-group .custom-search-button:focus {
		box-shadow: none !important;
		border-color: #009587 !important;
	}

	#app .custom-input-group .custom-search-button:hover {
		border-color: #009587 !important;
		background-color: rgba(0, 0, 0, 0.03) !important; 
	}

</style>